import React, { Component } from 'react'
import footerLogo from '../../images/logo_W.svg'
import PoliceIcon from '../../images/police-icon.png'
import './index.css'
export default class Footer extends Component {
  render() {
    return (
      <div>
        <div className='footer'>
          <img src={footerLogo} alt='' />
          <p className='content'> 邮箱：litao@precisource.com <span className='placeholder'></span>地址：北京市海淀区花园北路25号E园EPARK(花园路社区) </p>
          <p className='content'>©北京嘉云升科技有限公司 京ICP备16053646号-2</p>
          <p className='p-content'> 邮箱：litao@precisource.com</p>
          <p className='p-content'>地址：北京市海淀区花园北路25号E园EPARK(花园路社区) </p>
          <p className='p-content'>©北京嘉云升科技有限公司 京ICP备16053646号-2</p>
        </div>
        <div style={{ width: '300px', margin: '0 auto', padding: '20px 0',textAlign:'center' }}>
          <a target="_blank" href=" " style={{ display: 'inline-block', textDecoration: 'none', height: '20px', lineHeight: '20px' }}>
            <img src={PoliceIcon} style={{ float: 'left' }} />
            <p style={{ float: 'left', height: '20px', lineHeight: '20px', margin: '0px 0px 0px 5px', color: '#939393' }}>京公网安备 11010802038558号
            </p>
          </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Footer/index.js